"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EUtilsError = /** @class */ (function (_super) {
    __extends(EUtilsError, _super);
    function EUtilsError(message, uid) {
        var _this = _super.call(this, message) || this;
        _this.apiError = false;
        if (typeof uid === 'boolean') {
            _this.apiError = true;
        }
        else {
            _this.uid = uid;
        }
        return _this;
    }
    return EUtilsError;
}(Error));
exports.EUtilsError = EUtilsError;
